// extracted by mini-css-extract-plugin
export default {"form":"FailedForm_form__wlWDG","title":"FailedForm_title__GX+ho","item":"FailedForm_item__nM6uK","ani":"FailedForm_ani__QB9Fm"};